import React, { useState, useEffect } from 'react';
import DashboardGuest from './Dashboard';
import Weather from '../Admin/Weather';
import WhatsNew from '../Admin/WhatNew';
import styled from 'styled-components';
import bg1 from '../Assets/bg/bg5.jpg';
import bg2 from '../Assets/bg/Pilar.jpg';
import bg3 from '../Assets/bg/SanMiguel.jpg';
import bg4 from '../Assets/bg/Capayas.jpg';
import bg5 from '../Assets/bg/Ubay.jpg';
import Map from '../Components/Map';

const HomeGuest = ({ userRole }) => {  // Pass userRole as a prop
  const [backgroundIndex, setBackgroundIndex] = useState(0);


  const images = [bg1, bg2, bg3, bg4, bg5];
  const [showWhatsNew, setShowWhatsNew] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setBackgroundIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);


  return (
    <Container>
         <BottomQuoteWrapper>
        <DescriptionBox>
          <QuoteIcon>❝</QuoteIcon>
          <WelcomeText>
            Every drop of water invested in the land is a step toward a future full of growth and abundance.
          </WelcomeText>
          <QuoteAuthor>— Digital Irrigator System</QuoteAuthor>
        </DescriptionBox>
      </BottomQuoteWrapper>
      <ContentWrapper>
        
        <DashboardGuest  bgImage={images[backgroundIndex]} />

        <MainSection>
          <Weather />
          <Map />
        </MainSection>
        
        <WhatsNew showWhatsNew={showWhatsNew} setShowWhatsNew={setShowWhatsNew} />
      </ContentWrapper>

     
    </Container>
  );
};

export default HomeGuest;

// Styled Components (Same as before)
const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow-y: auto;
  margin-top: 30px;

`;

const ContentWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 20px;
  margin-top: -20px;
`;

const MainSection = styled.div`
  display: flex;
  gap: 20px;
  flex-grow: 1;
  justify-content: space-between;
`;

const BottomQuoteWrapper = styled.div`
  width: 125%;
  display: flex;
  margin-left: 60px;
  justify-content: center;
  padding: 20px 0;
  background-color: #f4f4f4;
`;

const DescriptionBox = styled.div`
  max-width: 1000px;
  width: 50%;
  background: linear-gradient(135deg, rgba(23, 136, 102, 0.95), rgba(0, 150, 136, 0.95), rgba(76, 175, 80, 0.95));
  padding: 5px 90px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  position: relative;
  animation: fadeIn 1.5s ease-in-out;
  color: #fff;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const QuoteIcon = styled.div`
  font-size: 2.5rem;
  color: #ffffffcc;
  position: absolute;
  top: 10px;
  left: 30px;
`;

const WelcomeText = styled.h1`
  font-size: 1.6rem;
  line-height: 1.4;
  font-weight: 600;
  text-align: left;
  margin: 0;
  padding: 10px 0 0 25px;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.5px;
`;

const QuoteAuthor = styled.p`
  margin-top: 20px;
  text-align: right;
  font-style: italic;
  color: #e0e0e0;
  font-size: 1rem;
  font-weight: 400;
`;
